import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@crashx/ui";
import type { RainReceived } from "@crashx/shared";
import { useChatStore } from "./chatStore.js";

export function RainToast({ receipt }: { receipt: RainReceived }) {
  const { t } = useTranslation();
  useEffect(() => {
    const timer = setTimeout(() => useChatStore.getState().dismiss(receipt.id), 12000);
    return () => clearTimeout(timer);
  }, [receipt.id]);
  return (
    <div role="status" className="cx-toast" style={{ borderColor: "var(--cx-color-success)" }}>
      <p className="m-0">{t("chat.received", { amount: receipt.amount })}</p>
      <Button
        variant="ghost"
        aria-label={t("notifications.dismiss")}
        onClick={() => useChatStore.getState().dismiss(receipt.id)}
      >
        {t("notifications.close")}
      </Button>
    </div>
  );
}
